import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Cmg1003LookupsModel } from '../../cmg-1003/models';

function createInitialState(): Cmg1003LookupsModel {
  return <Cmg1003LookupsModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-lookups-store', resettable: false })
export class Cmg1003LookupsStore extends Store<Cmg1003LookupsModel> {
  constructor() {
    super(createInitialState());
  }
}
